import { buildKioskPath, getRuntimeUrlState, sanitizeKioskSlug } from './core';

const LOG_PREFIX = '[Service:EntrLegacyUrlCompat]';

export interface LegacyLaunchState {
  isLegacyLaunch: true;
  slug: string;
  debug: boolean;
  hash: string;
}

function log(message: string): void {
  if (import.meta.env.DEV) {
    console.info(message);
  }
}

export function getLegacyLaunchState(): LegacyLaunchState | null {
  if (typeof window === 'undefined') return null;

  const runtimeState = getRuntimeUrlState();
  if (runtimeState.slug) return null;

  const currentUrl = new URL(window.location.href);
  const rawLegacySlug = currentUrl.searchParams.get('slug');
  const legacySlug = sanitizeKioskSlug(rawLegacySlug);
  if (!legacySlug) return null;

  if (rawLegacySlug && legacySlug !== rawLegacySlug) {
    log(
      `${LOG_PREFIX} sanitized legacy ?slug= "${rawLegacySlug}" -> "${legacySlug}"`
    );
  }

  return {
    isLegacyLaunch: true,
    slug: legacySlug,
    debug: currentUrl.searchParams.has('debug'),
    hash: currentUrl.hash,
  };
}

export function replaceLegacyLaunchWithBootstrapPath(slug: string): void {
  if (typeof window === 'undefined') return;

  const currentUrl = new URL(window.location.href);
  currentUrl.pathname = buildKioskPath();
  currentUrl.searchParams.delete('slug');

  const nextUrl = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;
  window.history.replaceState(window.history.state, '', nextUrl);
  log(`${LOG_PREFIX} replaceLegacyLaunchWithBootstrapPath(): ${nextUrl}`);
}
